import { HttpRequest } from "@angular/common/http";

export function cloneRequest(request: HttpRequest<unknown>, token: string) {
	return request.clone({
		setHeaders: {
			Authorization: `Bearer ${token}`
		}
	});
}
